import { useEffect, useState } from "react";
import { connect } from "react-redux";
import { useMediaQuery } from "@mui/material";
import toast from "react-hot-toast";

import { LogGenerateLink } from "../../redux/v2/user/actions";
import { GetDischargedPatients, GetEmailTemplates, GetPrompt, GetPatientInviteLogs, } from "../../redux/v2/patient-invite/actions";
import { SetModalProperties } from "../../redux/v2/utils/actions";
import { GetPrograms } from "../../redux/v2/program/actions";
import { ScreenType } from "../../utils/breakpoints";

import PatientListV2 from "./Components/PatientListV2";
import FAQPrograms from "./Components/FAQPrograms";
import PaddedContentArea from "../../common/PaddedContentArea";
import PIList from "./Components/PIList";
import CustomButton from "../../common/CustomButton";

import "./style.css";

function PatientInvite(props) {
    const { account } = props.User;
    const { list, count } = props.PatientInvite?.patients;
    const { list: etList, count: etCount } = props.PatientInvite?.emailTemplates;
    const { list: cetList, count: cetCount } = props.PatientInvite?.customEmailTemplates;

    const { programs: indiPrograms } = props?.Program

    const [allPrograms, setAllPrograms] = useState([]);
    const [allProgramsWLevels, setAllProgramsWLevels] = useState([]);
    const [sortedCETList, setSortedCETList] = useState([]);

    const screenSize = ScreenType(useMediaQuery);

    useEffect(() => {
        props?.GetEmailTemplates(1, 100, { owner: null }, null);
        props?.GetPrograms();
        props.GetPrompt("email-filter-prompt", "emailFilterPrompt");
        props.GetPrompt("generate-email-prompt", "emailPrompt");
    }, []);

    useEffect(() => {
        if (account?.user?.id) {
            props?.GetEmailTemplates(1, 100, { owner: account?.user?.id }, null);
        }
    }, [account?.user?.id]);

    useEffect(() => {
        if (cetList) {
            const sList = cetList?.sort((a, b) => {
                const dateA = new Date(a?.updated_at);
                const dateB = new Date(b?.updated_at);

                if (dateA < dateB) return 1;
                if (dateA > dateB) return -1;
                return 0; // If dates are equal
            });

            setSortedCETList(sList);
        }

    }, [cetList?.length]);

    useEffect(() => {
        let temp = {}, temp2 = [], level;
        for (let x = 0; x < indiPrograms?.length; x++) {
            temp["p-" + indiPrograms[x]?.id] = indiPrograms[x];

            if (!indiPrograms[x]?.beginner && !indiPrograms[x]?.moderate && !indiPrograms[x]?.advanced) {
                level = 0;
            } else if (indiPrograms[x]?.beginner) {
                level = 1;
            } else if (indiPrograms[x]?.moderate) {
                level = 2;
            } else if (indiPrograms[x]?.advanced) {
                level = 3;
            }

            temp2.push({
                ...indiPrograms[x],
                level: level,
            });
        }
        setAllPrograms(temp);
        setAllProgramsWLevels(temp2);
    }, [indiPrograms]);

    const getSuggestedPrograms = (programIDs, limit = 3) => {
        if (!programIDs) return [];

        programIDs = JSON.parse(programIDs);

        let id = "";
        let suggestedPrograms = [];

        for (let x = 0; x < (programIDs?.length <= limit ? programIDs?.length : limit); x++) {
            id = (programIDs[x] + "").split("-");
            suggestedPrograms.push({
                ...allPrograms["p-" + id[0]],
                level: id?.[1] ? ["", "BEGINNER", "MODERATE", "ADVANCED"][id?.[1] * 1] : null
            });
        }


        return suggestedPrograms;
    }



    return (
        <div id="patient-invite">
            {/* <PaddedContentArea> */}
            <div id="pi-container">
                <div id="pi-header">
                    <h4>Why Recommend indi?</h4>
                    <span>
                        Recommend indi to help patients safely progress post-discharge with PT-designed workouts, helping to maintain their success.
                    </span>

                    <div id="pl-invite-link-wrapper">
                        <CustomButton disabled={!account?.user?.id} className='active' onClick={async () => {
                            const link = `${process.env.REACT_APP_ENVIRONMENT === "PROD" ? process.env.REACT_APP_APP_URL : process.env.REACT_APP_APP_URL_DEV}?type=therapistinvite&id=${account?.user?.id}&event_id=${new Date().getTime()}&e=${(process.env.REACT_APP_ENVIRONMENT).toLowerCase()[0]}`;
                            await navigator.clipboard.writeText(link);
                            toast.success("Copied to Clipboard!")
                            props.LogGenerateLink();
                        }}>
                            Invite Link
                        </CustomButton>
                    </div>
                </div>

                <div id="pi-content">
                    <PIList screenSize={screenSize} etList={etList} cetList={sortedCETList} getSuggestedPrograms={getSuggestedPrograms} SetModalProperties={props?.SetModalProperties} />
                    <FAQPrograms programs={allProgramsWLevels} />
                </div>
            </div>
            {/* </PaddedContentArea> */}
        </div>
    );
}

const mapStateToProps = (state) => ({
    PatientInvite: state.PatientInvite,
    Program: state.Program,
    User: state.User,
});

export default connect(mapStateToProps, {
    GetDischargedPatients,
    GetEmailTemplates,
    SetModalProperties,
    GetPrograms,
    GetPrompt,
    GetPatientInviteLogs,
    LogGenerateLink,
})(PatientInvite);
